import styled from '@emotion/styled'
import { Table } from 'components/patterns'

export const StyledTable = styled(Table)`
  margin-top: 16px;
`
